import React, { useEffect, useState } from 'react';
import {
  Container,
  TableDataRow,
  TableRow,
  TableHeader,
  Table,
  Module,
  Description,
  UserName,
  TimeStamp,
  TableHead,
  TabledBody,
} from '@app/modules/activity-log/activity-log-component';
import { SelectOption, ActivityLogProps } from '@app/types';
import moment from 'moment';
import { getActivityUserName } from '@app/modules/transaction-details/transactions-details';

type Props = {
  activityLog: ActivityLogProps[];
};
const headers = [
  { label: 'Module', value: 'module' },
  { label: 'Description', value: 'description' },
  { label: 'User Name', value: 'username' },
  { label: 'Timestamp', value: 'timestamp' },
];
export default function ActivityLogList({ activityLog }: Props) {
  const [tableData, setTableData] = useState<any>([]);

  useEffect(() => {
    if (activityLog && activityLog.length) {
      const data = activityLog.map(
        (activity: ActivityLogProps, index: number) => {
          return {
            module: activity.item,
            description: activity.item + ' ' + activity.description,
            username: getActivityUserName(activity.user ? activity.user : ''),
            timestamp: activity.date
              ? moment(activity.date).format('MMM DD,YYYY hh:mm A')
              : '',
          };
        },
      );
      setTableData(data);
    }
  }, [activityLog]);

  return (
    <>
      <Container>
        <Table>
          <TableHead>
            <TableRow>
              {headers.map((header: SelectOption, index: number) => {
                return <TableHeader key={index}>{header.label}</TableHeader>;
              })}
            </TableRow>
          </TableHead>
          <TabledBody>
            {tableData.map((data: any, key: number) => {
              return (
                <TableDataRow key={key}>
                  <Module>{data.module || '--'}</Module>
                  <Description>{data.description || '--'}</Description>
                  <UserName>{data.username || '--'}</UserName>
                  <TimeStamp>{data.timestamp || '--'}</TimeStamp>
                </TableDataRow>
              );
            })}
          </TabledBody>
        </Table>
      </Container>
    </>
  );
}
